import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlusLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"plus-large, add large"} maskId="square-filled-radius-0-stroke-1-IconPlusLarge"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 3V11.5H21V12.5H12.5V21H11.5V12.5H3V11.5H11.5V3H12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPlusLarge;
